export const ChevronDownIcon = ({ className }: { className: string }) => {
  return (
    <svg
      className={`stroke-current ${className}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 7l5.625 5.625L15.25 7"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
